import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

// MUI Imports
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export const TableFilterBar = ({ filter, setFilter, invalidateQuery }) => {
  const [currentSearchValue, setCurrentSearchValue] = useState(
    filter.search || "",
  );
  const queryClient = useQueryClient();

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
    invalidateListQuery();
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
    invalidateListQuery();
  };

  const invalidateListQuery = () => {
    queryClient.invalidateQueries({
      queryKey: invalidateQuery,
      exact: true,
    });
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 1 }}>
      <Box component="form" onSubmit={handleSearchSumbit} sx={{ flexGrow: 1 }}>
        <TextField
          onChange={handleSearchChange}
          value={currentSearchValue}
          label="Search.."
          id="table-search"
          name="Search"
          variant="outlined"
          size="small"
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      visibility: currentSearchValue ? "visible" : "hidden",
                    }}
                  >
                    <IconButton onClick={handleSearchClear} color="error">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      </Box>
    </Stack>
  );
};
